export const SERVER_TIMEOUT =
  "The server took too long to respond, please try again shortly."
export const BAD_REQUEST = "Sorry, something went wrong. Please try again."
export const INTERNAL_ERROR =
  "Sorry, something went wrong. Please try again or contact info@abios.se if the error persists."

export const NOT_AUTHED = "NOT_AUTHED"

export const ABIOS_CUSTOMER_ID = "abiosdev"
